var map = {
	"./bender.png": 6887,
	"./circle_square.png": 9809,
	"./circles.png": 4344,
	"./getintouch.png": 8393,
	"./identitaDigitale.png": 2384,
	"./motoreInteresse.png": 7421,
	"./notarizeMe.png": 3541,
	"./opener.png": 5210,
	"./phone-fifth.png": 6423,
	"./phone-first.png": 4674,
	"./phone-fouth.png": 5318,
	"./phone-second.png": 3798,
	"./phone-third.png": 8107,
	"./squares.png": 5275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1828;